/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsSidebar = {
      init: function() {
    
        const facetedFilterForm = document.querySelector('[data-faceted-filter-form]')
        if (facetedFilterForm) {
          facetedFilterForm.addEventListener('change', e => {
            if (e.target.type == 'range') return;
           console.log('Form data before submission:', new FormData(facetedFilterForm));
            //facetedFilterForm.submit();
            Options(facetedFilterForm);
            //console.log(e.target);
          });
        }
       function Options(facetedFilterForm){
         const url = window.location.origin + window.location.pathname;
         const filterItem = $(".faceted-filter-group-display__list-item-input:checked");
         $('.faceted-filter-group-display__list-item-input:not(:checked)').removeClass("active");
         const productsContainer = $('.collection__main');
         const activeTags = {};
         let newUrl = url;
          filterItem.each(function (index) {
            const tag = $(this).attr('name');
            const value = encodeURIComponent(this.value); // Encode special characters
            if (url.indexOf(tag) == -1) {
                $(this).addClass('active');
                activeTags[tag] = value; // Use the encoded value
                newUrl += (index == 0) ? '?' + tag + '=' + value : '&' + tag + '=' + value;
            }
            
          });
         for (var key in activeTags) {
            const index = Object.keys(activeTags).indexOf(key);
          }
         
         Shopify.theme.jsSidebar.loadProducts(newUrl,productsContainer,$(".sidebar-section"))
         
         return false; 
       }
        const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');
    
        openSidebarBlocks.forEach(function(block){
          Shopify.theme.jsSidebar.openSidebarBlock($(block));
        })
    
    
        $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="closed"]', function (e) {
    
          e.preventDefault();
          Shopify.theme.jsSidebar.openSidebarBlock($(this));
        });
    
        $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="open"]', function(e) {
    
          e.preventDefault();
          Shopify.theme.jsSidebar.closeSidebarBlock($(this));
        });
    
        if ($('[data-product-sidebar]').length) {
          $('.section--has-sidebar-option').addClass('has-sidebar-enabled');
          $('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
        } else {
          $('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
          $('.section--has-sidebar-option').addClass('has-sidebar-disabled');
    
        }
    
      },
      updateStatusCount : function() {
        $(".sidebar_filter_block").each(function(){
          var inputs = $(this).find(".faceted-filter-group-display__list-item-input:checked");
          var countContainer = $(this).find("[data-has-toggle-option] .faceted-filter-group-summary__active-count");
          if(inputs && inputs.length > 0){
              countContainer.addClass("active");
              countContainer.text("("+(inputs.length)+")").css("display","initial");
          }else {
            countContainer.removeClass("active");
          }
        });
      },
      loadProducts : function (url,productsContainer,sidebarForm) {
        productsContainer.addClass("ajax-loading")
        $.get({
            url: url,
            success: function (data) {
                var newProductsWrapper = $(data).find(".collection__main");
                var newProductsHtml = newProductsWrapper.html();
                var newPaginationHtml = $(data).find(".paginate").parent().html();
                var sidebarFormHtml = $(data).find(".sidebar-section").html();
                sidebarForm.html(sidebarFormHtml)
                productsContainer.html(newProductsHtml);
                const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');
                openSidebarBlocks.forEach(function(block){
                  Shopify.theme.jsSidebar.openSidebarBlock($(block));
                })
                Shopify.theme.jsSidebar.updateStatusCount();
                //var newItemCount = newProductsWrapper.attr('data-products-count');
                //$('.js-product-grid__count').text(newItemCount);
                
                $('.paginate').parent().html(newPaginationHtml);
               // var pagination = $("#AjaxinatePagination");
                history.pushState({
                    page: url
                }, null, url);
    
                $('.collection__main').removeClass('ajax-loading');
                Shopify.theme.jsSidebar.init();
                $(".collection_page #drawer-container").css("left", "0");
                var sourceDiv = $("#sourceDiv");
                var destinationDiv = $("#destinationDiv");
                var clonedContent = sourceDiv.clone(true);
                destinationDiv.empty();
               destinationDiv.append(clonedContent);
               $('input.faceted-filter-group-display__list-item-input:checked').each(function() {
        $(this).parent("label.faceted-filter-group-display__list-item-label").parent(".faceted-filter-group-display__list-item").siblings('.faceted-filter-group-display__list-item').addClass('disabledFilterItem');
    });
              
            }
        })
      },
      openSidebarBlock: function ($toggleBtn) {
    
        const $parentBlock = $toggleBtn.closest('.sidebar__block');
        const $toggleIcon = $toggleBtn.find('.icon');
    
        $toggleBtn.attr('data-sidebar-block__toggle', 'open');
    
        $parentBlock.addClass('is-active');
        $parentBlock.attr('aria-expanded', true);
        $parentBlock.find('[data-sidebar-block__content--collapsible]').slideDown();
      },
      closeSidebarBlock: function ($toggleBtn) {
    
        const $parentBlock = $toggleBtn.closest('.sidebar__block');
        const $toggleIcon = $toggleBtn.find('.icon');
    
        $toggleBtn.attr('data-sidebar-block__toggle', 'closed');
    
        $parentBlock.removeClass('is-active');
        $parentBlock.attr('aria-expanded', false);
        $parentBlock.find('[data-sidebar-block__content--collapsible]').slideUp();
      },
      unload: function() {
        const $toggleBtn = $('[data-sidebar-block__toggle]');
        $toggleBtn.off();
      }
    }
    
    /******/ })()
    ;